import React, { useState } from 'react';
import axios from 'axios';

function DataDeletionForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleInputChange = (event) => {
    setEmail(event.target.value);
  };

  const handleDataDeletionRequest = async () => {
    // Replace with your API endpoint
    const url = 'https://your-api-endpoint.com/data-deletion-request';
    try {
      const response = await axios.post(url, { email });
      if (response.status === 200) {
        setStatus("Your data deletion request has been successfully received. Please check your email for further instructions.");
      } else {
        throw new Error();
      }
    } catch (error) {
      setStatus("There was an issue processing your request. Please try again later.");
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '50%',
      margin: 'auto',
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#fff',
    }}>
      <input
        style={{
          padding: '10px',
          width: '100%',
          marginBottom: '15px',
          borderRadius: '5px',
          border: '1px solid #ccc',
          fontSize: '16px',
        }}
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={handleInputChange}
      />
      <button 
        style={{
          padding: '10px 20px',
          backgroundColor: '#4caf50',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '18px',
        }}
        onClick={handleDataDeletionRequest}
      >
        Request Data Deletion
      </button>
      {status && 
        <p style={{marginTop: '20px', fontSize: '16px'}}>
          {status}
        </p>
      }
    </div>
  );
}

export default DataDeletionForm;
